//햄버거 사이드 바 영역
import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoIcon from "../../assets/svg/Logo";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          {/* <LogoIcon /> */}
          <h1 className="whiteColor font20" style={{ marginLeft: "15px" }}>
            reMIND
          </h1>
        </div>
        <CloseBtn
          onClick={() => toggleSidebar(!sidebarOpen)}
          className="animate pointer"
        >
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <NavItem className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="home"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Home
          </Link>
        </NavItem>
        <NavItem className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="services"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Services
          </Link>
        </NavItem>
        <NavItem className="semiBold font15 pointer">
          <a
            href="https://www.instagram.com/remind_cookie/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ padding: "10px 15px" }}
            className="whiteColor"
          >
            Instagram
          </a>
        </NavItem>
        
      </UlStyle>
      <UlStyle className="flexSpaceCenter">
        {/*<li className="semiBold font15 pointer">
          <a
            href="https://www.instagram.com/remind_cookie/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ padding: "10px 30px 10px 0" }}
            className="whiteColor"
          >
            Instagram
          </a>
        </li>*/}
        {/*<li className="semiBold font15 pointer flexCenter">
          <a
            href="https://linktr.ee/remind4u"
            target="_blank"
            rel="noopener noreferrer"
            className="radius8 lightBg"
            style={{ padding: "10px 15px" }}
          >
            앱 출시 이벤트 진행중
          </a>
        </li>*/}
      </UlStyle>
    </Wrapper>
  );
}

const NavItem = styled.li`
  margin: 20px 0;

  a {
    padding: 10px 15px;
    color: white;
    transition: color 0.3s ease;

    &:hover,
    &:active {
      color: #2a2a2a;
    }
  }
`;


const Wrapper = styled.nav`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-100%")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
